import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { getQuery } from 'y4/Utils';

const Blank = () => {
  const location = useLocation();
  const to = getQuery(location.search, 'url');

  return <Navigate to={to}></Navigate>;
};

export default Blank;
